<template>
  <div class="app" v-title data-title="富林印迹-广富林文化遗址公园">
    <component :is="headerComponent" :activeIndex="1" />
    <div class="yj-banner rel">
      <img src="@/assets/images/yj-banner.png" class="db wp100" alt="banner">
      <div class="crumbs-nav df align_center justify_end fa_wh box-border">
        <router-link to="/" class="f16 fw">首页</router-link>
        <img src="@/assets/images/arrow-wh-05.png" class="db w20 ml5 mr5" alt="">
        <router-link to="/pages/yinxiang/index" class="f16 fw">印象富林</router-link>
      </div>
      <div class="yj-banner-tit df align_center flex_column justify_center ts fw">
        <div class="f50 ls1 b">印象富林</div>
        <div class="f17 ls3">Impressions of Guangfulin</div>
      </div>
      <div class="yj-nav wp100">
        <div class="yj-nav-item df align_center justify_center">
          <div class="yj-nav-box active">
            <router-link to="/pages/yinxiang/index" class="yj-nav-link db f24">富林印迹</router-link>
          </div>
          <div class="yj-nav-box">
            <router-link to="/pages/yinxiang/yinxiang-yizhi" class="yj-nav-link db f24">遗址挖掘</router-link>
          </div>
        </div>
      </div>
    </div>
    <div class="index-box1">
      <div class="index-box1-bg mt20">
        <div class="index-box1-line df align_center justify_end">
          <img src="@/assets/images/yj-box-line.png" class="db" alt="">
        </div>
        <div class="w1600 auto df justify_end">
          <div class="yj-box1">
            <h2 class="yj-box1-tit b f32 ls1">广富林文化公园概括</h2>
            <div class="yj-box1-text f16 cell_bk tj pt10" v-if="summarize && summarize.ContentText" v-html="summarize.ContentText">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="yj-box2 mt120">
      <div class="yj-tab">
        <ul class="df align_center justify_center f20 yj-tab-item" v-if="bottom && bottom.length > 0">
          <li v-for="item in bottom" :key="item.Id" :class="bottomActive == item.Id ? 'active' : ''" @click="bottomChange(item.Id)" class="yj-tab-box">{{ item.Name }}</li>
        </ul>
      </div>

      <div class="yj-main">
        <div class="yj-main-box" v-if="bottom && bottom.length > 0">
          <div class="yj-main-text mt20 df align_center justify_center" style="height: 100px;">
            <img src="@/assets/images/yj-bracket-lt.png" class="db" alt="" />
            <div class="f18 foo yj-main-intro ml15 mr15 lh18" v-html="bottomContent.text"></div>
            <img src="@/assets/images/yj-bracket-rt.png" class="db" alt="" />
          </div>
          <div class="yj-main-pic mt20">
            <img :src="bottomContent.photoUrl + '!/both/1905x635'" class="db wp100" alt="">
          </div>
        </div>
      </div>
    </div>
    <component :is="bottomComponent" />
  </div>
</template>

<script>
import Header from '../../components/header.vue'
import Bottom from '../../components/bottom.vue'
import promotionService from '@/services/client/cont/promotion'

export default {
  name: 'app',
  data () {
    return {
      headerComponent: 'Header',
      bottomComponent: 'Bottom',
      summarizeCode: 'app-yxfl-flyj',
      summarize: null,
      bottomCode: 'app-yxfl-flyj-bottom',
      bottom: null,
      bottomCotent: {
        photoUrl: '',
        text: '',
      },
      bottomActive: null,
    }
  },
  components: { Header, Bottom,},
  mounted() {
    this.loadSummarize();
    this.loadBottom();
  },
  methods:{
    loadSummarize() {
      promotionService.detail(this.summarizeCode).then(res => {
        if(res.Code == 200) {
          let data = res.Data;
          this.summarize = data.Items[0];
        }
      })
    },
    loadBottom() {
      promotionService.detail(this.bottomCode).then(res => {
        if(res.Code == 200) {
          let data = res.Data;
          this.bottom = data.Items;
          // 默认底部激活样式
          if(data.Items && data.Items.length > 0) {
            var first = data.Items[0];
            this.bottomActive = first.Id;

            this.bottomContent = {
              photoUrl: first.Photo,
              text: first.ContentText,
            }
          }
        }
      })
    },
    bottomChange(activeId) {
      this.bottomActive = activeId;
      const obj = this.bottom.find(item => item.Id == activeId);
      this.bottomContent = {
        photoUrl: obj.Photo,
        text: obj.ContentText,
      }
    }
  },

}
</script>



// WEBPACK FOOTER //
// src/views/yinxiang/index.vue